import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'dolomite',
    description:
      'Dolomite agent for Ascend and Princeton architecture questions.',
    icon: 'tools',
    name: 'Dolomite',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
